export default __webpack_public_path__ + "static/media/fpb41000.4acb5441.png";